export type {
  ReceiptWidthMm,
  SaleReceiptDocument,
  SaleReceiptLine,
  SaleReceiptPayload,
  SaleReceiptPayment,
  ThermalPrintDocument,
} from './types';
export type {
  FiscalReceiptDocument,
  FiscalReceiptLine,
  FiscalReceiptPayload,
} from './fiscalTypes';
export {
  buildFiscalComprobante,
  renderFiscalComprobanteEscPos,
  formatComprobanteNumber,
  formatFiscalCuit,
  normalizeFiscalBuyerName,
  fiscalDiscriminatesIva,
} from './buildFiscalComprobante';
export { buildSaleReceipt, renderSaleReceiptEscPos } from './buildSaleReceipt';
export { encodeEscPosPlainText } from './escposPlainText';
export {
  formatReceiptMoney,
  formatReceiptWhen,
  escapeReceiptHtml,
  receiptCharsPerLine,
  receiptPlainTextCols,
} from './format';
export {
  receiptColsForBrowser,
  receiptColsForEscPos,
  receiptSeparatorLine,
  receiptJustifyLine,
  receiptItemBlock,
  receiptItemExtrasBlock,
  receiptKitchenItemBlock,
  receiptRightAlignLine,
  receiptTotalLine,
  receiptWrapLine,
} from './receiptPlainLayout';
export {
  RECEIPT_FONT_FAMILY,
  RECEIPT_INK,
  RECEIPT_SEPARATOR,
  receiptPlainDocumentCss,
} from './receiptTypography';
export type { ThermalPlainLineRole } from './receiptTypography';
export {
  wrapThermalHtml,
  wrapThermalPlainTextHtml,
  wrapThermalPlainDocumentHtml,
  thermalHtmlStyles,
  thermalItemRowsHtml,
} from './renderThermalHtml';
